import { getColor } from "../utils/dashboard.utils";

export const deviceOptions= {
    chart: {
      renderTo: "container",
      type: "bar",
      height: "70px",
      marginTop: 0,
      animation: false,
    },

    credits: {
      enabled: false,
    },

    legend: {
      enabled: false,
    },

    title: {
      text: undefined,
    },
    tooltip: {
      enabled: false,
    },

    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
      max: 100,
    },

    plotOptions: {
      series: {
        states: {
          inactive: {
            opacity: 1,
          },
          hover: {
            opacity: 0.9,
          },
        },
        stacking: "percent",
        pointWidth: 24,
        groupPadding: 0,
        dataLabels: {
          enabled: true,
          align: "right",
          // verticalAlign: "top",
          y: -2,
          style: {
            color: "#fffff",
            fontFamily: "Roboto, sans-serif",
            fontSize: "max(0.8vw, 12px)",
            fontWeight: "light",
            boxShadow: "none",
            textOutline: "none",
            overflow: "ellipsis",
            position: "relative",
            top: "-5px",
          },
          formatter: function () {
            const self = this as any;
            const percent = self.percentage as number;
            if (percent < 20) {
              return "";
            }
            let minutes = this.y as number;
            const hours = Math.floor(minutes / 60);
            minutes = minutes % 60;
            const timeString =
              (hours != 0 ? hours + "h " : "") +
              (minutes != 0 ? minutes + "m " : "");
            return timeString;
          },
        },
      },
      column: {
        grouping: false,
      },
    },

    series: [
                {data: [48], name: 'laptop', color: getColor('Computer')},
                {data: [18], name: 'mobile', color: getColor('Tablet')},
                {data: [34], name: 'tablet', color: getColor('Mobile')} 
    ],
  }